import type { FC, PropsWithChildren } from "react";
import { createContext, useContext, useMemo, useState } from "react";

export type IShowRegistrationOnboardingContext = {
    showRegistrationOnboarding: boolean;
    setShowRegistrationOnboarding: (value: boolean) => void;
};

export const ShowRegistrationOnboardingContext = createContext<IShowRegistrationOnboardingContext>({
    showRegistrationOnboarding: false,
    setShowRegistrationOnboarding: () => {},
});

export const useShowRegistrationOnboardingContext = () => useContext(ShowRegistrationOnboardingContext);

export const ShowRegistrationOnboardingContextProvider: FC<PropsWithChildren> = ({ children }) => {
    const [showRegistrationOnboarding, setShowRegistrationOnboarding] = useState(false);

    const context = useMemo(
        () => ({ showRegistrationOnboarding, setShowRegistrationOnboarding }),
        [showRegistrationOnboarding, setShowRegistrationOnboarding],
    );

    return (
        <ShowRegistrationOnboardingContext.Provider value={context}>
            {children}
        </ShowRegistrationOnboardingContext.Provider>
    );
};
